export default __webpack_public_path__ + "images/BJ.a387700.png";